import API from '../../../../services/api-middleware';
import { NestedRecord } from '../../../../utils/context';
import type { GeminiModelItem } from '../settings.props';

const baseUrl = process.env.REACT_APP_LLM_SERVER_URL;
const appBaseUrl = process.env.REACT_APP_USER_SERVER_URL;

export const getOptimizationModel = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).get(`/optimization-model`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postOptimizationModel = async (payload: NestedRecord) => {
  const data = { ...payload };
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(baseUrl).post(`/optimization-model`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateGeminiKey = async (payload: {
  gemini_key: string;
  user_id: number;
}): Promise<{ data: GeminiModelItem[] }> => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).post('/update-gemini-key', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteGeminiKey = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).delete('/delete-gemini-key', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateGeminiModels = async (payload: {
  models: GeminiModelItem[];
  user_id: number;
}): Promise<{ message: string }> => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).post('/update-gemini-models', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOnboardedGeminiKey = async () => {
  try {
    let token = localStorage.getItem('token');
    if (token !== null) {
      token = JSON.parse(token);
    }
    const response = await API(appBaseUrl).get(`/get-gemini-key`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
